// Identity in online play. A match is hosted by exactly one room; a room seats exactly the players its backend
// matched (its roster), in roster order.

import { OnlineInvariantError } from './errors'
import { expectMatching } from './wire'

declare const roomIdBrand: unique symbol
declare const playerKeyBrand: unique symbol
declare const seatBrand: unique symbol

/** The authoritative room of one match: a Cloudflare room Durable Object's name, or a PlayFab session id (= match id). */
export type RoomId = string & { readonly [roomIdBrand]: true }
/** A matched player inside one backend: a Cloudflare ticket's player key, or a PlayFab title_player_account id. */
export type PlayerKey = string & { readonly [playerKeyBrand]: true }
/** A player's index in its room's roster. */
export type Seat = number & { readonly [seatBrand]: true }

const ROOM_ID_PATTERN = /^[A-Za-z0-9-]{8,64}$/
const PLAYER_KEY_PATTERN = /^[A-Za-z0-9_-]{1,64}$/

export function parseRoomId(value: unknown): RoomId {
  return expectMatching(value, ROOM_ID_PATTERN, 'room id') as RoomId
}

export function parsePlayerKey(value: unknown): PlayerKey {
  return expectMatching(value, PLAYER_KEY_PATTERN, 'player key') as PlayerKey
}

/** A roster index from trusted code; anything else is a programmer error. */
export function seatOf(index: number, seats: number): Seat {
  if (!Number.isInteger(index) || index < 0 || index >= seats) throw new OnlineInvariantError(`seat ${index} is outside a ${seats}-seat room`)
  return index as Seat
}
